import { ConcernTypeDto } from '@core/services/dto/concern-type.dto';
export class ConcernTypeModel {
  label: string;
  value: number;
  constructor(dto: ConcernTypeDto) {
    this.value = dto.id;
    this.label = dto.name;
  }
}
